import '@scouts/ui/dist/reset.css'

import isPropValid from '@emotion/is-prop-valid'
import { PostHogProvider } from 'posthog-js/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { StyleSheetManager } from 'styled-components'

import { store } from '@/store'

import App from './components/App'
import config from './config'

const container = document.getElementById('root')

if (!config.postHogKey || !config.postHogHost) throw new Error('Error: PostHog: Environment key or host not set')

if (!container) throw new Error('Failed to find the `#root` element')

const root = createRoot(container)

root.render(
    <PostHogProvider
        apiKey={config.postHogKey}
        options={{ api_host: config.postHogHost, capture_pageview: false, person_profiles: 'identified_only' }}
    >
        <Provider store={store}>
            <StyleSheetManager shouldForwardProp={isPropValid}>
                <App />
            </StyleSheetManager>
        </Provider>
    </PostHogProvider>
)
